import MfButton from '@components/branded/MfButton'
import PropTypes from 'prop-types'
import './MfGridComponent.css'

/**
 * Renders action/crud buttons for the data grids
 * @param {Object} props - Component props
 * @param {string} [props.type='normal'] - Button type ('back', 'danger', 'default', 'normal', 'success')
 * @param {string} [props.stylingMode='outlined'] - Button styling mode
 * @param {string} [props.icon] - Icon name to display on the button
 * @param {boolean} [props.disabled=false] - Whether the button is disabled
 * @param {Function} props.onClick - Click handler function
 * @param {string} [props.text] - Text to display on the button
 * @param {string|number} [props.width='auto'] - Button width
 * @param {string|number} [props.height='auto'] - Button height
 * @param {boolean} [props.isLink=false] - Whether the button behaves as a link
 * @returns {JSX.Element} The rendered button component
 */
const RenderButtons = ({
  type = 'normal',
  stylingMode = 'outlined',
  icon,
  disabled = false,
  onClick,
  text,
  width = 'auto',
  height = 'auto',
  isLink = false
}) => {
  const buttonAttribs = { className: 'grid-buttons grid-buttons-icon' }

  return (
    <span className="grid-buttons-padding grid-buttons-icon">
      <MfButton
        component="dx"
        disabled={disabled}
        elementAttr={buttonAttribs}
        height={height}
        icon={icon}
        id={`${icon}-${isLink}`}
        onClick={onClick}
        style={{ justifyContent: 'center' }}
        stylingMode={stylingMode}
        text={text}
        type={type}
        width={width}
      />
    </span>
  )
}

RenderButtons.propTypes = {
  type: PropTypes.oneOf(['back', 'danger', 'default', 'normal', 'success']),
  stylingMode: PropTypes.string,
  icon: PropTypes.string,
  disabled: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  text: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isLink: PropTypes.bool
}

export default RenderButtons
